import api from "../Api";
import { BaseService } from "../BaseService";

const URL = 'home-backgrounds';

export class HomeBackgroundService extends BaseService {
    async listActive(): Promise<any[]> {
        try {
            return this.handleResponse(await api.get(`${URL}/active`));
        } catch (e: any) {
            return this.catchHandler(e);
        }
    }
}
